// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"cfb60cc6","106":"653f6d42","292":"aa1d3520","387":"568e1ce3","468":"c021fba1"}[chunkId] + ".chunk.css";
};